import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor{

  constructor(protected router: Router, private authService: AuthenticationService){ }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{ 
    const modifiedReq = req.clone({withCredentials: true});
    
    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) 
          this.authService.logout();
        
        return throwError(() => error);
      })
    );
  }
}
